export default __webpack_public_path__ + "static/media/EOR.022a10a5.svg";